import React from 'react';
import styles from './CaseLeaderboard.module.scss';
import CaseLeadCard from './CaseLeadCard';
import { ReactComponent as Group } from '@/assets/Icons/Group1.svg';

const CaseLeaderboard = ({ leaderboard }: { leaderboard: any }) => {
  // Логируем структуру данных для отладки
  console.log('CaseLeaderboard data:', leaderboard);

  // Проверяем, что leaderboard и его свойства существуют
  if (!leaderboard || !leaderboard.user || !leaderboard.leaders) {
    return (
      <div className={styles.container}>
        <div className={styles.leaderboardContainer}>
          <div className={styles.leaderboardTitle}>Загрузка рейтинга...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.yourPosition}>
        <CaseLeadCard
          position={leaderboard.user.rank || 0}
          name={leaderboard.user.name || 'Пользователь'}
          rewardNumber={leaderboard.user.reward?.amount || 0}
          photoUrl={leaderboard.user.photo_url || ''}
          open={leaderboard.user.opens}
          isYou={true}
        />
      </div>

      <div className={styles.leaderboardContainer}>
        <div className={styles.columnHeaders}>
          <div className={styles.headerPosition}>Nº</div>
          <div className={styles.headerUser}>Участники</div>
          <div className={styles.headerHacks}>Взломы</div>
          <div className={styles.headerRewards}>Награды</div>
        </div>
        <div className={styles.leaderboard}>
          {leaderboard.leaders.map((reward: any, index: number) => (
            <CaseLeadCard
              key={reward.user_id || index}
              position={reward.rank || index + 1}
              name={reward.name || 'Пользователь'}
              rewardNumber={reward.reward?.amount || 0}
              photoUrl={reward.photo_url || ''}
              open={reward.opens}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseLeaderboard;
